// extracted by mini-css-extract-plugin
export default {"timeline":"c81ebdc2f98e","url":"df996d241ff0","startIcon":"ebc9884edf1f","endIcon":"fd6d9e29706d"};